import { PlanningStatus } from './data.const';

export const planningStatusLabel: Record<string, string> = {
	[PlanningStatus.Ready]: 'On track',
	[PlanningStatus.OnTrack]: 'Vertraagd (t.o.v. tussentijds streefdoel)',
	[PlanningStatus.Insufficient]: 'Ontoereikende planning',
};
